<script setup lang="ts">
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import ToggleSwitch from '@/components/Interface/ToggleSwitch/ToggleSwitch.vue'
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore'
import { computed } from 'vue'

const playerFlagsStore = usePlayerFlagsStore()

const isTerraformingDefaultEnabled = computed(() => {
  return playerFlagsStore.getFlag('tutorial_terraforming_default') === 'true'
})

// Toggle handler for terraforming default
const handleTerraformingDefaultToggle = async () => {
  const newValue = isTerraformingDefaultEnabled.value ? 'false' : 'true'
  await playerFlagsStore.setFlag('tutorial_terraforming_default', newValue)
}
</script>

<template>
  <StandardCard title="Terraforming">
    <div class="flex justify-between items-center">
      <div>
        <p>Set planets to automatically terraform when captured/settled</p>
        <small>(When terraforming tech is available)</small>
      </div>
      <div class="flex items-center pb-1">
        <ToggleSwitch
          :modelValue="isTerraformingDefaultEnabled"
          @update:modelValue="handleTerraformingDefaultToggle"
        />
      </div>
    </div>
  </StandardCard>
</template>

<style scoped lang="scss">

</style>